import React, { Component } from 'react';
import Stack from 'react-bootstrap/Stack';
import Welcome from '../Welcome/Welcome';
import Age from '../Age/Age';
import Loss from '../Loss/Loss';
import Sound from '../Sound/Sound';
import Effort from '../Effort/Effort';
import Telephone from '../Telephone/Telephone';
import Quiet from '../Quiet/Quiet';
import Searching from '../Searching/Searching';
import Result from '../Result/Result';
import MoreInfo from '../../containers/MoreInfo/MoreInfo';
import StatModelMoreInfo from '../../containers/StatModelMoreInfo/StatModelMoreInfo';
import Disclaimer from '../../containers/Disclaimer/Disclaimer';
import BodyIcon from '../../components/BodyIcon/BodyIcon';
import NetlifyIdentityComponent from '../../components/NetlifyIdentifier/NetlifyIdentityComponent';
import {Row, Col, Container} from 'react-bootstrap';
import { MdRestartAlt } from "react-icons/md";
import { IoMdArrowBack } from "react-icons/io";
import {IDStatus} from '../../components/NetlifyIdentifier/NetlifyIdentityComponent';
import Strings from 'localization/Strings';
import MyButton from '../../components/MyButton/MyButton';
import { FaUserCircle } from "react-icons/fa";
import { FaMale, FaFemale } from "react-icons/fa";
import PaperReferencer from '../../components/PaperReferencer/PaperReferencer';
import ReferencesModal from '../../components/ReferencesModal/ReferencesModal';
import Modal from 'react-bootstrap/Modal';
import Summary from 'components/Summary/SummaryComponent';
import './PageContainer.css';

const viewName = {  
    Welcome: 0,
    Age: 1,
    Loss: 2,
    Sound: 3,
    Effort: 4,
    Telephone: 5,
    Quiet: 6,
    Searching: 7,
    Result: 8,
    MoreInfo: 9,
    StatModelMoreInfo: 100,
};  
const next_step_links = {
    brief: {
        us: 'https://adulthearing.com/referral-support-tool-next-steps',
        uk: 'https://adulthearing.com/referral-support-tool-next-steps',
        ja: 'https://adulthearing.com/referral-support-tool-next-steps',
    },
    full: {
        us: 'https://www.cochlear.com/us/en/connect/find-a-clinic',
        uk: 'https://www.cochlear.com/uk/en/professionals/resources/resources-materials',
        ja: 'https://www.cochlear.com/us/ja/connect/find-a-clinic',
    },
};

class PageContainer extends Component {
    animationTime = 200; //ms
    inputModel = {
        user_selection_age:null, 
        user_selection_loss:null, 
        user_selection_ssq_clarity:null, 
        user_selection_ssq_effort:null,
        user_selection_ssq_telephone:null,
        user_selection_ssq_OoO:null,
    }
    state = {
        viewName: viewName.Welcome,
        statModelMoreInfoCallerViewName: null,
        counter: 0,
        showModal: false,
        showReferencesModal: false,
    };
    constructor(props){
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.gotoPrevious = this.gotoPrevious.bind(this);
        this.gotoStart = this.gotoStart.bind(this);
        this.gotoStatModelMoreInfo = this.gotoStatModelMoreInfo.bind(this);
        this.gotoResult = this.gotoResult.bind(this);
        this.gotoNextStepPage = this.gotoNextStepPage.bind(this);
        this.statModel = null;
        this.netlifyIdentityComponent = React.createRef();
        this.isBriefMode = props.isBriefMode || false;
        this.lang = props.lang || 'us';

        
        // Check if we should skip welcome page and start from Age question
        if (this.isBriefMode) {
            this.state.viewName = viewName.Age;
        }
    }

      componentDidMount() {
        // this.netlifyIdentityComponent?.current?.refresh();
      } 

    render () {
        const handleClose = () => this.setState({showModal: false});
        return (
            <div className=''>
                <Modal show={this.state.showModal} onHide={handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    size='lg'
                    centered>
                    <Modal.Body>
                        <span onClick={handleClose} className='close-button'>
                            ✕
                        </span>
                        <Summary model={this.inputModel} className="" />
                    </Modal.Body>
                    <div  className='noticed-pad smoke120-bg white100'>
                        <div className=' sub-heading1 white100'>
                            {Strings.strings.Summary.NoticeTitle}
                        </div>
                        <ul className='noticed-pad-list sub-heading2 '>
                            <li> 
                                {Strings.strings.Summary.noticeItem1}
                            </li>
                            <li>
                                {Strings.strings.Summary.noticeItem2}
                            </li>
                            <li>
                                {Strings.strings.Summary.noticeItem3}
                            </li>
                            <li> 
                                {Strings.strings.Summary.noticeItem4}
                            </li>
                        </ul>                             
                    </div>
                </Modal> 
                <div className="container-fluid my-container-outter">
                    <div className="my-container-inner">
                        <Stack gap={0} className="my-content">
                            <Container fluid className='ribbon-container'>
                                <Row className="ribbon-row" >
                                    <Col className='ribbon-row-left-col' xs={10}>
                                        {this.getBackButton()}
                                        {this.getRestartButton()}
                                        {this.getSummaryRibbon()}
                                    </Col>
                                    <Col  className='ribbon-row-right-col'>
                                        <NetlifyIdentityComponent ref={this.netlifyIdentityComponent} onLogoutHandler={this.gotoStart}/>
                                    </Col>
                                </Row>
                            </Container>
                            {/* <a href='#' className='loginButton' onClick={() => {this.netlifyIdentityComponent.current?.refresh()}}>test</a> */}
                            <div className="my-card" bg="light">
                                {this.getSubView()}
                            </div>
                            {this.bodyicon()}
                            {this.disclaimer()}
                        </Stack>
                    </div>
                </div>
                <ReferencesModal 
                    show={this.state.showReferencesModal} 
                    onHide={() => this.setState({showReferencesModal: false})} 
                />
            </div>
        );
    }
    changeView(viewName, checkAuthentication=true, withAnimation=true) {
        // this.netlifyIdentityComponent?.current?.refresh();
        // var authenticationStatus = this.netlifyIdentityComponent?.current?.authenticated();
        let authenticationStatus = null;
        checkAuthentication = false; // disable authentication check for now
        if (!checkAuthentication || authenticationStatus === IDStatus.authenticated || viewName === viewName.Welcome) {
            this.timeout = setTimeout(() => {
                this.setState({viewName: viewName});
            }, withAnimation ? this.animationTime : 1);
            return; 
        }
        else if(authenticationStatus === IDStatus.expired) {
            // console.log(this.netlifyIdentityComponent.current);
            this.netlifyIdentityComponent.current?.refreshToken(() => {
                //console.log("--------------- refreshed token ---------------");
                this.setState({viewName: viewName});
                //this.refresh();
            }, () => {
                //console.log("--------------- failed to refresh token ---------------");
                // in the following, it again retries to login.
            });
        }
        // this.netlifyIdentityComponent?.current?.tryLogIn(()=> {
        //     this.setState({viewName: viewName});
        // });
    }

    gotoStart() {
        // If we entered via /lang/q1, restart should go to Age, not Welcome
        const startView = this.isBriefMode ? viewName.Age : viewName.Welcome;
        this.changeView(startView, false);
    }
    onSubmit(data) {
        this.updateModelAsync(data);
        let nextView = this.state.viewName < viewName.MoreInfo ? this.state.viewName + 1 : this.state.viewName;
        
        //For debug =================================
        // this.inputModel = {
        //     user_selection_age:"<50", 
        //     user_selection_loss:"severe to profound", 
        //     user_selection_ssq_clarity:1, 
        //     user_selection_ssq_effort:2,
        //     user_selection_ssq_telephone:3,
        //     user_selection_ssq_OoO:4,
        // }
        // nextView = viewName.Searching;
        //end of debug =================================

        this.changeView(nextView);
    }
    gotoResult(statModel) {
        this.statModel = statModel;
        this.changeView(viewName.Result);
    }
    gotoStatModelMoreInfo(callerViewName = null) {
        this.setState({statModelMoreInfoCallerViewName: callerViewName })
        this.changeView(viewName.StatModelMoreInfo);
    }
    gotoPrevious() {
        if (this.state.viewName === viewName.StatModelMoreInfo) {
            this.gotoStart();
            return;
        }
        let previousView = this.state.viewName > viewName.Welcome ? this.state.viewName - 1 : viewName.Welcome;
        this.changeView(previousView);
    }
    gotoNextStepPage() {
        const modeKey = this.isBriefMode ? 'brief' : 'full';
        const langKey = this.lang || 'us';
        const url = next_step_links[modeKey]?.[langKey] ?? next_step_links.full.us;
        if (this.isBriefMode) {
            try {
                // Cross-origin safe: assigning top.location is allowed in many iframe contexts.
                window.top.location = url;
                return;
            } catch (error) {
                // Some sandbox policies block top navigation; use a fallback.
            }

            const topWindow = window.open(url, '_top');
            if (!topWindow) {
                // Last resort keeps the button functional even when top navigation is blocked.
                window.location.assign(url);
            }
        } else {
            window.location.assign(url);
        }
    }
    
    async updateModelAsync(data) {
        this.inputModel = {...this.inputModel, ...data}; 
    }
    getSubView(){
        switch (this.state.viewName) {
            case viewName.Welcome:
                //return <TextChartFunctions />;
                return <Welcome onSubmit={this.onSubmit} onMoreInfo={this.gotoStatModelMoreInfo}/>;
            case viewName.Disclaimer:
                return <Disclaimer />;
            case viewName.Age:
                return <Age onSubmit={this.onSubmit} />;
            case viewName.Loss:
                return <Loss onSubmit={this.onSubmit} StatModelMoreInfo={() => this.gotoStatModelMoreInfo(viewName.Loss)} isBriefMode={this.isBriefMode} />;
            case viewName.Sound:
                return <Sound onSubmit={this.onSubmit} />;
            case viewName.Effort:
                return <Effort onSubmit={this.onSubmit} />;
            case viewName.Telephone:
                return <Telephone onSubmit={this.onSubmit} />;
            case viewName.Quiet:
                return <Quiet onSubmit={this.onSubmit} />;
            case viewName.Searching:
                return <Searching model={this.inputModel} onNext= {this.gotoResult} onRestart={this.gotoStart} accessToken={this.netlifyIdentityComponent?.current?.currentUser()?.token?.access_token} />;
            case viewName.Result:
                return <Result onRestart={this.gotoStart} onSubmit={this.gotoNextStepPage} statModel={this.statModel} StatModelMoreInfo={() => this.gotoStatModelMoreInfo(viewName.Result)} isBriefMode={this.isBriefMode} />;
            case viewName.MoreInfo:
                return <MoreInfo onRestart={this.gotoStart} onSubmit= {this.onSubmit}/>;
            case viewName.StatModelMoreInfo:
                return <StatModelMoreInfo />;
            default:
                <Welcome />;
        }
    }
    getActivePercent(){
        switch (this.state.viewName) {
            case viewName.Welcome:
                return 100
            case viewName.Age:
                return 83;
            case viewName.Loss:
                return 75;
            case viewName.Sound:
                return 67;
            case viewName.Effort:
                return 50;        
            case viewName.Telephone:
                return 33;        
            case viewName.Quiet:
                return 17;        
            default:
                return -1;
        }
    }
    getBackButton(){
        var onclick = this.gotoPrevious;
        if (this.state.viewName === viewName.Welcome){
            return null;
        }
        else if (this.state.viewName === viewName.Searching) {
            return null;
        }
        else if (this.state.viewName === viewName.Result) {
            return null;
        }
        else if (this.state.viewName === viewName.StatModelMoreInfo && this.state.statModelMoreInfoCallerViewName){
            onclick = () =>
                    this.changeView(this.state.statModelMoreInfoCallerViewName);
        }
        return (
            <MyButton type="transparent" onClick={onclick}>
                <IoMdArrowBack />              
            </MyButton>            
        );
    }  
    getRestartButton(){
        if (this.state.viewName === viewName.Welcome){
            return null;
        }
        if (this.state.viewName === viewName.Searching){
            return null;
        }
        if (this.state.viewName === viewName.StatModelMoreInfo){
            return null;
        }
        return (
            <MyButton type="transparent"  onClick={this.gotoStart}>
                <MdRestartAlt />              
            </MyButton>
        );
    }
    getSummaryRibbon(){
        if (this.state.viewName !== viewName.Result){
                return null;
        }
        return (
            <span className='sub-heading2'>
                <span className='ribbon-based-on'>{Strings.strings.Results.RibbonBasedOn}</span>
                <span className='ribbon-you-tag' onClick={() => this.ShowSummaryPage()}>
                    <FaUserCircle className='summary-list-item-in-text-icon' />
                    <span className=''>{Strings.strings.Results.RibbonYou}</span>
                </span>

                <span className='ms-2' dangerouslySetInnerHTML={{ __html: Strings.strings.Results.RibbonText}}></span>
                <PaperReferencer refIndex={[7, 8, 9, 10]} className="smoke100" onClick={() => this.setState({showReferencesModal: true})} />
                <FaFemale  className='iconTop ms-1'/>
                <FaMale className='iconTop'/>
            </span>  
        );
    }  
    ShowSummaryPage(){
        this.setState({showModal: true})
    }


    bodyicon(){
        let percent = this.getActivePercent()
        if(percent < 0){
            return (<></>);
        }
        return (
            <div className="my-card-footer pb50">
                <BodyIcon activePercent={percent}/>
            </div>
        );
    }    
    disclaimer(){
        if(this.state.viewName === viewName.Welcome){
            return (
                <div className="my-card-footer caption1 smoke120 disclamer-text">
                    <p>{Strings.strings.Disclaimer.Disclaimer}</p>
                </div>
            );
        }
    }
}

export default PageContainer;